export class BankPaymentResponse {
  reference: string;
  clientId: string;
  paymentUrl: string;
  status: string;
  providerResponse: string;
}

export enum ResponseCodes {
  success = "00",
  error = "01",
  visaResponse = "S0",
  tokenResponse = "T0",
  pendingResponse = "02",
  authorizationRequired = "03",
  validationError = "VALIDATION_ERROR",
  resourceNotFound = "RESOURCE_NOT_FOUND",
}

export interface StatusResponse<T> {
  status: boolean;
  data: T;
}

export interface AccountData {
  data: Account[];
}

export interface Account {
  accountNumber: string;
  accountCode: string;
  fullname: string;
}

// export interface BankPaymentRequest {
//   reference: string;
//   clientId: string;
//   narration: string;
//   accountNumber: string;
//   bankCode: string;
//   accountName: string;
//   channel: string;
// }

export interface BankPaymentRequest {
  customer: Customer;

  authorization: Authorization;
  reference: string;
  clientId: string;
  planReference?: string;
}

export interface Customer {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  address: string;
}

export interface Authorization {
  accountNumber: string;
  bankCode: string;
  accountName: string;
  narration: string;
  provider?: string;
}

export interface ValidateAccount {
  userId: string;
  paymentReference: string;
  clientId?: string;
}
